module.exports = __webpack_public_path__ + "img/Type_Dark.d92883ea.png";